import React from 'react'
import styled from "styled-components";

const Wrapper = styled.footer`
    text-align: center;
    font-size: 12px;
    background-color: white;
    padding: 20px 0;
    color: #999;
    margin-top: 40px;
`

const Footer = () => (
    <Wrapper>
        Diário 24 Horas © 2020
    </Wrapper>
)

export default Footer;